export default (element) => {
  if (element.$el) {
    element?.$el.scrollIntoView({ behavior: "smooth" });
  } else {
    element?.scrollIntoView({ behavior: "smooth" });
  }
};
